var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-steps",class:[
     !_vm.simple && 'el-steps--' + _vm.direction,
     _vm.simple && 'el-steps--simple'
   ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }